import { Exit, Option, Schema } from 'effect';

import { AccessoriesHistoryState, HistoryState } from '@vs-shop/schemas/history/filterHistoryState';
import { ourFilterData } from './historyStatePatcher';

export function saveAccessoriesTaxonToHistoryState(
  taxonCode: string | null,
  productCode: string
): void {
  if (typeof window === 'undefined') return;

  const currentRawState: Record<string, unknown> =
    (window.history.state as Record<string, unknown> | null) ?? {};

  const accessoriesState = Schema.encodeSync(AccessoriesHistoryState)({
    taxonCode,
    productCode,
    timestamp: Date.now(),
  });

  ourFilterData.accessoriesFilters = accessoriesState;

  const newState = { ...currentRawState, accessoriesFilters: accessoriesState };

  const url = new URL(window.location.href);
  const pageParam = url.searchParams.get('accessoriesPage');

  url.search = '';
  if (pageParam) url.searchParams.set('accessoriesPage', pageParam);

  window.history.replaceState(newState, '', url.toString());
  window.dispatchEvent(new Event('pushstate'));
}

export function getAccessoriesTaxonFromHistoryState(
  productCode: string
): Option.Option<string | null> {
  if (typeof window === 'undefined') {
    return Option.none();
  }

  const stateResult = Schema.decodeUnknownExit(HistoryState)(window.history.state);

  if (Exit.isFailure(stateResult)) {
    return Option.none();
  }

  const { accessoriesFilters } = stateResult.value;

  if (!accessoriesFilters) {
    return Option.none();
  }

  const accessoriesResult = Schema.decodeExit(AccessoriesHistoryState)(accessoriesFilters);

  if (Exit.isFailure(accessoriesResult)) {
    return Option.none();
  }

  if (accessoriesResult.value.productCode !== productCode) {
    return Option.none();
  }

  return Option.some(accessoriesResult.value.taxonCode);
}
